module.exports = __webpack_public_path__ + "img/vedio_down_code.f58f0428.png";